import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { StatusApprovalsPipe } from '@fuse/pipes/approvals-status/status-translate.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ApprovalsEquipmentsService } from 'app/main/approvals-equipments/services/approvals-equipments.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabApprovalsEquipmentsComponent = /** @class */ (function () {
    function TabApprovalsEquipmentsComponent(approval, fuseTranslationLoaderService, formBuilder, statusApprovalsPipe, translateService, approvalsEquipmentsService) {
        this.approval = approval;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.formBuilder = formBuilder;
        this.statusApprovalsPipe = statusApprovalsPipe;
        this.translateService = translateService;
        this.approvalsEquipmentsService = approvalsEquipmentsService;
        this.isExistingNumber = false;
        this.disableButtonApproval = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TabApprovalsEquipmentsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var existingEquipment;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.approvalForm = this.formBuilder.group({
                            name: [{ value: this.approval.equipment.name, disabled: true }, [Validators.required]],
                            number: [{ value: this.approval.equipment.number, disabled: true }, [Validators.required]],
                            qrCode: [{ value: this.approval.equipment.qrCode, disabled: true }, [Validators.required]],
                            notes: [{ value: this.approval.equipment.notes, disabled: true }, [Validators.required]],
                            company: [{ value: this.approval.company.name, disabled: true }, [Validators.required]],
                            locationName: [{ value: this.approval.equipment.location.name, disabled: true }, [Validators.required]],
                            locationSectorName: [{ value: this.approval.equipment.locationSector ? this.approval.equipment.locationSector.name : '', disabled: true }, [Validators.required]],
                            locationEnvironmentName: [{ value: this.approval.equipment.locationEnvironment ? this.approval.equipment.locationEnvironment.name : '', disabled: true }, [Validators.required]],
                            locationFormattedAddress: [{ value: this.approval.equipment.location.address.formattedAddress, disabled: true }, [Validators.required]],
                            type: [{ value: this.approval.equipment.type.name, disabled: true }, [Validators.required]],
                            approvalCreatedAt: [{ value: moment(this.approval.createdAt).format('DD/MM/YYYY HH:mm'), disabled: true }, [Validators.required]],
                            approvalStatus: [{ value: this.statusApprovalsPipe.transform(this.approval.status), disabled: true }, [Validators.required]],
                            equipmentStatus: [{ value: (this.approval.equipment.archived ? this.translateService.instant('APPROVALS_EQUIPMENTS.INACTIVE') : this.translateService.instant('APPROVALS_EQUIPMENTS.ACTIVE')), disabled: true }, [Validators.required]]
                        });
                        if (!this.approval) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.approvalsEquipmentsService.searchEquipment(this.approval.equipment.number)];
                    case 1:
                        existingEquipment = _a.sent();
                        if (existingEquipment) {
                            this.isExistingNumber = true;
                            this.disableButtonApproval.next(this.isExistingNumber);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return TabApprovalsEquipmentsComponent;
}());
export { TabApprovalsEquipmentsComponent };
